import { fullscreenStateContext } from "providers/FullscreenStateProvider";
import { useContext } from "react";

export default function useFullscreenState() {
  const { fullscreen, fullscreenSet } = useContext(fullscreenStateContext);

  return [fullscreen, fullscreenSet];
}
